import SessionStorageHandler from './SessionStorageHandler';

import { Features } from '../data/Features';

const singleton = Symbol();
const singletonEnforcer = Symbol();

/* eslint eqeqeq: 0 */
export default class FeatureToggleService {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw new Error('Cannot construct FeatureToggleService');
        }
    }

    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new FeatureToggleService(singletonEnforcer);
        }
        return this[singleton];
    }

    initialiseServiceWithFeatures(features) {
        this.isBrowserCapable = SessionStorageHandler.isCapable();

        if (features) {
            this.features = features;
        } else {
            this.features = Features;
        }
    }

    chooseValueForFeature(name) {
        const feature = this.features.get(name);
        if (!feature) {
            return null;
        }

        const values = feature.get('values');
        if (!values || !Array.isArray(values) || !values.length) {
            return null;
        }

        const randomIndex = Math.floor(Math.random() * values.length);
        return values[randomIndex];
    }

    getFeatureValue(name) {
        if (!this.features || !this.features.get(name)) {
            return null;
        }

        if (!this.isBrowserCapable) {
            return this.features.get(name).get('defaultValue') != null ?
                this.features.get(name).get('defaultValue') : null;
        }

        const value = SessionStorageHandler.getItem(name);
        if (value == null) {
            const newValue = this.chooseValueForFeature(name);
            SessionStorageHandler.setItem(name, JSON.stringify(newValue));
            return JSON.stringify(newValue);
        }

        return value;
    }
}



// WEBPACK FOOTER //
// ./src/services/FeatureToggleService.js